import Axios from "axios";
import axiosClient from "./axiosClient";
const BaseURL: string = process.env.REACT_APP_API_URL ?? "";

type IReqBody = {
  bookingNumber: string;
  name: string;
  location: string;
  zip: string;
  streetHouseNumber: string;
  email: string;
  firstName: string;
  problem: string;
  telefonnummer: string;
};

async function emergancyRequest(reqBody: IReqBody) {
  try {
    const response = await axiosClient.post(`/emergancy/request`, reqBody);

    if (response.status !== 200) {
      console.warn(`api call response is not 200 ok!`);
      return null;
    }
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default emergancyRequest;
